export default function(ctx) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '<!-- rendered by both radio and selectboxes component -->\n';
 ctx.values.forEach(function(item) { ;
__p += '\n<div class="utrecht-form-field utrecht-form-field--' +
((__t = (ctx.component.inputType)) == null ? '' : __t) +
' utrecht-form-field--openforms">\n  <p class="utrecht-paragraph utrecht-form-field__label utrecht-form-field__label--' +
((__t = (ctx.component.inputType)) == null ? '' : __t) +
'">\n    <label\n      for="' +
((__t = (ctx.id)) == null ? '' : __t) +
'' +
((__t = (ctx.row)) == null ? '' : __t) +
'-' +
((__t = (item.value)) == null ? '' : __t) +
'"\n      class="utrecht-form-label utrecht-form-label--openforms utrecht-form-label--' +
((__t = (ctx.component.inputType)) == null ? '' : __t) +
' ';
 if (ctx.disabled) { ;
__p += 'utrecht-form-label--disabled';
 } ;
__p += '"\n    >\n      ' +
((__t = ( item.label )) == null ? '' : __t) +
'\n    </label>\n  </p>\n  <input\n    ref="input"\n    value="' +
((__t = (item.value)) == null ? '' : __t) +
'"\n    id="' +
((__t = (ctx.id)) == null ? '' : __t) +
'' +
((__t = (ctx.row)) == null ? '' : __t) +
'-' +
((__t = (item.value)) == null ? '' : __t) +
'"\n\n    ';
 for (var attr in ctx.input.attr) { ;
__p += '\n    ' +
((__t = (attr)) == null ? '' : __t) +
'="' +
((__t = (ctx.input.attr[attr])) == null ? '' : __t) +
'"\n    ';
 } ;
__p += '\n\n    ';
 if (ctx.value && (ctx.value === item.value || (typeof ctx.value === 'object' && ctx.value.hasOwnProperty(item.value) && ctx.value[item.value]))) { ;
__p += '\n    checked=true\n    ';
 } ;
__p += '\n\n    ';
 if (item.description) { ;
__p += '\n    aria-describedby="' +
((__t = (ctx.id)) == null ? '' : __t) +
'' +
((__t = (ctx.row)) == null ? '' : __t) +
'-' +
((__t = (item.value)) == null ? '' : __t) +
'-description"\n    ';
 } ;
__p += '\n  >\n  ';
 if (item.description) { ;
__p += '\n    <div class="utrecht-description utrecht-form-description--openforms" id="' +
((__t = (ctx.id)) == null ? '' : __t) +
'' +
((__t = (ctx.row)) == null ? '' : __t) +
'-' +
((__t = (item.value)) == null ? '' : __t) +
'-description">\n        ' +
((__t = ( item.description )) == null ? '' : __t) +
'\n    </div>\n  ';
 } ;
__p += '\n</div>\n';
 }) ;
__p += '\n';
return __p
}